import { useHistory, useLocation } from 'react-router-dom';
import CustomButton from '../CustomButton/CustomButton';
import styles from './index.scss';
import { authCallbackRoute, projetosRoute } from '../../library/Routes';
import { LogoProgramasEducacionais } from 'components/LogoProgramasEducacionais';
import icon404 from './../../assets/images/icon404.gif';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useEffect, useState } from 'react';
import AuthService from 'services/Auth/AuthService';
import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';

const rootClassName = styles.rootClassName;

const NotFoundScreen = () => {
  const { logout } = AuthService();
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const location = useLocation();
  const history = useHistory();
  const [isAuthRedirect, setIsAuthRedirect] = useState(false);

  const toHome = () => {
    history.push(projetosRoute.path);
  };

  useEffect(() => {
    if (location.pathname.includes(authCallbackRoute.path)) {
      setIsAuthRedirect(true);
      logout();
    }
  }, [location.pathname, logout]);

  if (isAuthRedirect) {
    return (
      <div className={rootClassName + '-container-auth-redirect'}>
        <LoaderGlobal />
      </div>
    );
  }

  return (
    <>
      <div className={rootClassName + '-container-404'}>
        <div className='container-images'>
          <LogoProgramasEducacionais width={200} />
          <img src={icon404} alt='icone-404' className={'icon-404'} loading='lazy' />
        </div>
        <div className='container-legend'>
          <p>{languageValues.error404}</p>
        </div>
        <CustomButton
          label={languageValues.voltaInicio}
          theme='pufvYellow'
          className={rootClassName + '-main-button'}
          onClick={toHome}
        />
      </div>
    </>
  );
};

export default NotFoundScreen;
